import {defineMessages} from 'react-intl'

/**
 *  define navItemsMessages translation
 */
export const navItemsMessages = defineMessages({
  flights: {
    id: 'wl.kwFlights',
    defaultMessage: 'Flights'
  },
  cars: {
    id: 'wl.kwCars',
    defaultMessage: 'Cars'
  },
  hotels: {
    id: 'wl.kwHotels',
    defaultMessage: 'Hotels'
  },
  magazine: {
    id: 'wl.kwMagazine',
    defaultMessage: 'Magazine'
  },
  extras: {
    id: 'wl.kwExtras',
    defaultMessage: 'Extras'
  },
  lastMinute: {
    id: 'wl.kwLastMinute',
    defaultMessage: 'Last minute'
  }
})
